import {  Typography } from "@mui/material"
import { PropertyTypeCardStyle } from './style'

export const SelectContract=({data})=>{
    const classes = PropertyTypeCardStyle()
    return(
            <Typography className={classes.label1}>{data ?? "Contract details"}</Typography>
    )
}